import React from 'react';

export const HandIcon = () => (
  <svg width="60px" height="90px" viewBox="0 0 60 90">
    <g
      id="HandIcon"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="Group-20">
        <path
          d="M21.25,57.7593 C21.25,57.7593 29.5,61.0093 35.25,63.0093 C41,65.0093 43.583,59.4263 38.25,56.7593 C32.25,53.7593 24,45.8423 20,45.8423 C16,45.8423 10,50.5093 10,50.5093 L9.75,69.0093 L20.25,69.0093 C20.25,69.0093 27.5,73.7593 30.5,73.7593 C33.5,73.7593 57.25,60.0093 57.25,60.0093 C57.25,60.0093 59.5,54.5093 54.25,54.5093 L41.5,59.5093"
          id="Fill-1"
          fill="#FFFFFF"
        />
        <path
          d="M53,15.5004022 C53,22.4037775 47.4035974,28 40.5,28 C33.5964026,28 28,22.4037775 28,15.5004022 C28,8.59622253 33.5964026,3 40.5,3 C47.4035974,3 53,8.59622253 53,15.5004022"
          id="Fill-3"
          fill="#DFCAE9"
        />
        <path
          d="M43.1699,19.1909 C43.1699,18.8929 43.1209,18.6179 43.0219,18.3659 C42.9219,18.1139 42.7619,17.8779 42.5379,17.6579 C42.3159,17.4399 42.0269,17.2379 41.6729,17.0519 C41.3169,16.8659 40.8809,16.6869 40.3629,16.5149 C39.7339,16.3219 39.1679,16.0979 38.6669,15.8429 C38.1659,15.5869 37.7399,15.2869 37.3889,14.9419 C37.0369,14.5969 36.7679,14.1989 36.5819,13.7479 C36.3969,13.2969 36.3039,12.7759 36.3039,12.1859 C36.3039,11.6349 36.3869,11.1319 36.5529,10.6779 C36.7189,10.2229 36.9549,9.8279 37.2639,9.4929 C37.5719,9.1579 37.9449,8.8859 38.3839,8.6769 C38.8209,8.4679 39.3159,8.3309 39.8659,8.2639 L39.8659,6.0849 L41.3499,6.0849 L41.3499,8.2739 C42.4639,8.4269 43.3319,8.8949 43.9509,9.6779 C44.5719,10.4609 44.8829,11.5319 44.8829,12.8919 L43.0509,12.8919 C43.0509,12.4469 42.9979,12.0389 42.8919,11.6679 C42.7849,11.2959 42.6289,10.9749 42.4189,10.7029 C42.2109,10.4309 41.9509,10.2179 41.6429,10.0659 C41.3339,9.9129 40.9809,9.8369 40.5829,9.8369 C40.1649,9.8369 39.8029,9.8929 39.4979,10.0059 C39.1929,10.1189 38.9409,10.2759 38.7419,10.4789 C38.5429,10.6809 38.3939,10.9249 38.2939,11.2099 C38.1939,11.4949 38.1449,11.8109 38.1449,12.1549 C38.1449,12.4739 38.1909,12.7609 38.2839,13.0159 C38.3769,13.2719 38.5329,13.5059 38.7519,13.7179 C38.9709,13.9299 39.2629,14.1309 39.6269,14.3199 C39.9919,14.5089 40.4499,14.6929 41.0009,14.8719 C41.6379,15.0779 42.2049,15.3089 42.7029,15.5639 C43.1999,15.8189 43.6189,16.1169 43.9619,16.4549 C44.3029,16.7939 44.5639,17.1849 44.7419,17.6289 C44.9219,18.0739 45.0119,18.5869 45.0119,19.1709 C45.0119,19.7489 44.9219,20.2659 44.7419,20.7239 C44.5639,21.1819 44.3069,21.5769 43.9709,21.9089 C43.6369,22.2399 43.2319,22.5059 42.7569,22.7049 C42.2829,22.9039 41.7539,23.0319 41.1699,23.0919 L41.1699,24.9929 L39.6969,24.9929 L39.6969,23.0919 C39.1869,23.0459 38.6929,22.9299 38.2189,22.7449 C37.7449,22.5589 37.3239,22.2899 36.9549,21.9379 C36.5879,21.5859 36.2939,21.1399 36.0739,20.5999 C35.8559,20.0589 35.7459,19.4099 35.7459,18.6539 L37.5879,18.6539 C37.5879,19.2179 37.6699,19.6859 37.8359,20.0579 C38.0019,20.4289 38.2189,20.7239 38.4879,20.9419 C38.7569,21.1619 39.0549,21.3139 39.3839,21.3999 C39.7119,21.4859 40.0419,21.5299 40.3739,21.5299 C40.8179,21.5299 41.2129,21.4759 41.5589,21.3659 C41.9029,21.2559 42.1949,21.1009 42.4339,20.8979 C42.6729,20.6959 42.8559,20.4499 42.9819,20.1619 C43.1079,19.8729 43.1699,19.5489 43.1699,19.1909"
          id="Fill-5"
          fill="#8A4CAE"
        />
        <path
          d="M55.078,15.54 C55.078,7.50942943 48.5688599,1 40.539,1 C32.5091401,1 26,7.50942943 26,15.54 C26,23.5697153 32.5092847,30.079 40.539,30.079 C48.5687153,30.079 55.078,23.5697153 55.078,15.54 Z"
          id="Stroke-7"
          stroke="#8A4CAE"
          strokeWidth="2"
        />
        <path
          d="M8.25624949,51.8749118 C8.25624949,51.8749118 16,45.8423 20,45.8423 C24,45.8423 32.25,53.7593 38.25,56.7593 C43.583,59.4263 41,65.0093 35.25,63.0093 C29.5,61.0093 21.25,57.7593 21.25,57.7593"
          id="Stroke-9"
          stroke="#8A4CAE"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M8.43285326,69.0093 L20.25,69.0093 C20.25,69.0093 27.5,73.7593 30.5,73.7593 C33.5,73.7593 55.344,61.1113 56.5,60.4263 C58.75,59.0923 58.5,57.3423 58,56.0093 C57.5,54.6763 55.834,53.7593 53.5,54.8423 C51.898,55.5863 41.5,59.5093 41.5,59.5093"
          id="Stroke-11"
          stroke="#8A4CAE"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M54,30.5093 C54,30.5093 59.75,47.0093 43,50.7593"
          id="Stroke-13"
          stroke="#8A4CAE"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeDasharray="2,3"
        />
        <path
          d="M32.875,87.0093 C32.875,88.4593 26.104,89.6343 17.75,89.6343 C9.396,89.6343 2.625,88.4593 2.625,87.0093 C2.625,85.5593 9.396,84.3843 17.75,84.3843 C26.104,84.3843 32.875,85.5593 32.875,87.0093"
          id="Fill-15"
          fill="#EBEBEB"
        />
        <polygon
          id="Fill-17"
          fill="#DFCAE9"
          points="0 73.2593 9.25 73.2593 9.25 46.7593 0 46.7593"
        />
        <path
          d="M1,72.2593 L8.25,72.2593 L8.25,47.7593 L1,47.7593 L1,72.2593 Z"
          id="Stroke-19"
          stroke="#8750A0"
          strokeWidth="2"
        />
      </g>
    </g>
  </svg>
);
